import React, { useEffect } from 'react'
import FormControl from '@material-ui/core/FormControl'
import MenuItem from '@material-ui/core/MenuItem'
import OutlinedInput from '@material-ui/core/OutlinedInput'
import Select from '@material-ui/core/Select'
import KeyboardArrowDownIcon from 'components/material-symbol/icons/KeyboardArrowDown'
import pipe from 'lodash/fp/pipe'
import { get } from 'lodash'
import uniqBy from 'lodash/fp/uniqBy'
import sortBy from 'lodash/fp/sortBy'

const outlinedSelectMenuProps = menuPaperClassName => ({
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left',
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'left',
  },
  getContentAnchorEl: null,
  classes: {
    paper: menuPaperClassName,
  },
  MenuListProps: {
    disablePadding: false,
  },
})

const LocationDropdown = ({
  selectedFacility,
  setSelectedFacility,
  locations = [],
  groupEventsLocations = [],
  programsLocations = [],
  setHasOneLocation = () => {},
  menuPaperClassName,
  classes: selectClasses,
  allOptionLabel = 'All Locations',
}) => {
  const isCompact = Boolean(menuPaperClassName)
  let allLocations = locations.concat(groupEventsLocations)
  allLocations = allLocations.concat(programsLocations)
  // the pipe function is treated as a curried function, can pass in the
  // arguments one at a time and it will return a new function that takes the
  // next argument. Acts similar to the '|' operator in bash to pass the results into the next function
  const uniqueSortedLocations = pipe(uniqBy('id'), sortBy('name'))(allLocations)

  uniqueSortedLocations.unshift({
    id: 'all',
    name: `${allOptionLabel} (${uniqueSortedLocations.length})`,
  })

  useEffect(() => {
    setHasOneLocation(uniqueSortedLocations.length <= 2)
  }, [uniqueSortedLocations.length, setHasOneLocation])

  useEffect(() => {
    // Keep the current selection when it is still valid. Only initialize (or
    // repair) after facilities resolve so we do not stick on a null value from
    // the empty first paint.
    setSelectedFacility(prev => {
      const prevId = prev && typeof prev === 'object' ? prev.id : prev
      const isValid =
        prevId != null &&
        prevId !== '' &&
        uniqueSortedLocations.some(location => location.id === prevId)
      if (isValid) {
        return prev
      }
      return get(uniqueSortedLocations, '0.id', 'all')
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uniqueSortedLocations.length])

  return (
    <FormControl
      variant="outlined"
      fullWidth={!isCompact}
      className={selectClasses?.formControl}
    >
      <Select
        value={selectedFacility || ''}
        variant="outlined"
        size={isCompact ? 'small' : 'medium'}
        displayEmpty
        IconComponent={KeyboardArrowDownIcon}
        onChange={e => setSelectedFacility(e.target.value)}
        input={
          isCompact ? (
            <OutlinedInput
              labelWidth={0}
              notched={false}
              classes={{
                root: selectClasses?.outlinedInput,
                input: selectClasses?.select,
                notchedOutline: selectClasses?.notchedOutline,
              }}
            />
          ) : (
            undefined
          )
        }
        classes={
          isCompact
            ? {
              select: selectClasses?.select,
              icon: selectClasses?.icon,
            }
            : undefined
        }
        MenuProps={
          menuPaperClassName
            ? outlinedSelectMenuProps(menuPaperClassName)
            : undefined
        }
      >
        {uniqueSortedLocations.map(({ id, name }) => (
          <MenuItem key={id} value={id}>
            {name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
export default LocationDropdown
